import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IGetTeamResData, IOrganizationTeamReducer} from '../../utils/types';

export const pendingOperation = (state: IOrganizationTeamReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationTeamReducer) => {
	state.isLoading = false;
};

export const createTeamMemberOperation = (state: IOrganizationTeamReducer) => {
	state.isLoading = false;
};

export const deleteTeamMemberOperation = (state: IOrganizationTeamReducer) => {
	state.isLoading = false;
};

export const updateTeamMemberRoleOperation = (state: IOrganizationTeamReducer) => {
	state.isLoading = false;
};

export const generatePasswordOperation = (state: IOrganizationTeamReducer, {payload}: PayloadAction<string>) => {
	state.password = payload;
};

export const getTeamMemberOperation = (state: IOrganizationTeamReducer, {payload}: PayloadAction<IGetTeamResData>) => {
	state.teamData = payload;
	state.isLoading = false;
};
